import { authCheck } from "@/axios/scope/userManage"

export const checkLogin = async (state) => {
  let formData = new FormData();
  formData.append('tempToken',state)
  const params = new URLSearchParams(formData)
  const result = await authCheck(params);
  if(result.token){
    console.error('checkLogin---',result)
    if(result.userRole == 10){
      window.location.href = 'https://www.tianyagygg.com/nopower'
    }else{
      localStorage.setItem("Login-Type", "30");
      localStorage.setItem("token", result.token);
      localStorage.setItem("userName", result.nickname);
      localStorage.setItem('headImage',result.headimgurl)
      window.location.href = 'https://www.tianyagygg.com/'
    }
    
  }else{
    checkLogin();
  }
}